export default __webpack_public_path__ + "static/media/icon-phone-white.76f3b91a.svg";